// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_gq-","importantInfo":"styles_importantInfo__VLs91"};